import './index.css';
import Navbar from './navbar';
import Footer from './footer';
import logo from './Logo .png';
import ccLogo from './cc_logo.png'
import drawing from './Drawing Final.png'
import { useState, useEffect, useRef } from 'react';
import Matter from 'matter-js';
import { motion, AnimatePresence } from 'framer-motion';


export default function Home() {
  const [filter, setFilter] = useState("all");
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const physicsContainerRef = useRef(null);

  // Matter.js Physics Background
  useEffect(() => {
    const Engine = Matter.Engine,
      Render = Matter.Render,
      Runner = Matter.Runner,
      Bodies = Matter.Bodies,
      Composite = Matter.Composite,
      Mouse = Matter.Mouse,
      MouseConstraint = Matter.MouseConstraint;

    const engine = Engine.create();
    const world = engine.world;
    world.gravity.y = 0.5;

    const render = Render.create({
      element: physicsContainerRef.current,
      engine: engine,
      options: {
        width: window.innerWidth,
        height: window.innerHeight,
        wireframes: false,
        background: 'transparent'
      }
    });

    Render.run(render);
    const runner = Runner.create();
    Runner.run(runner, engine);

    // Create blocky shapes
    const shapes = [];
    for (let i = 0; i < 15; i++) {
      const x = Math.random() * window.innerWidth;
      const y = Math.random() * -500;
      const size = 30 + Math.random() * 50;
      let body;
      if (Math.random() > 0.5) {
        body = Bodies.rectangle(x, y, size, size, {
          render: { fillStyle: i % 2 === 0 ? '#4DFF55' : '#3B82F6', strokeStyle: '#000', lineWidth: 2 }
        });
      } else {
        body = Bodies.polygon(x, y, 3, size / 2, {
          render: { fillStyle: i % 3 === 0 ? '#000' : '#FFF', strokeStyle: '#000', lineWidth: 2 }
        });
      }
      shapes.push(body);
    }

    const ground = Bodies.rectangle(window.innerWidth / 2, window.innerHeight + 50, window.innerWidth, 100, { isStatic: true });
    const leftWall = Bodies.rectangle(-50, window.innerHeight / 2, 100, window.innerHeight, { isStatic: true });
    const rightWall = Bodies.rectangle(window.innerWidth + 50, window.innerHeight / 2, 100, window.innerHeight, { isStatic: true });

    Composite.add(world, [...shapes, ground, leftWall, rightWall]);

    // Add mouse control
    const mouse = Mouse.create(render.canvas);
    const mouseConstraint = MouseConstraint.create(engine, {
      mouse: mouse,
      constraint: {
        stiffness: 0.2,
        render: { visible: false }
      }
    });
    Composite.add(world, mouseConstraint);

    const handleResize = () => {
      render.canvas.width = window.innerWidth;
      render.canvas.height = window.innerHeight;
    };
    window.addEventListener('resize', handleResize);

    return () => {
      Render.stop(render);
      Runner.stop(runner);
      Engine.clear(engine);
      render.canvas.remove();
      render.textures = {};
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Body Scroll Lock for Modal
  useEffect(() => {
    if (selectedProject) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => { document.body.style.overflow = 'unset'; };
  }, [selectedProject]);

  // Custom Cursor Tracker
  useEffect(() => {
    const moveCursor = (e) => {
      setCursorPos({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', moveCursor);
    return () => window.removeEventListener('mousemove', moveCursor);
  }, []);

  const projects = [
    {
      title: "Martin Garrix Store",
      tech: "React + CSS + JavaScript",
      img: "https://i.pinimg.com/564x/5e/99/42/5e99422940624f762625a5dbec3210c9.jpg",
      description: "A concept e-commerce platform designed for fans of Martin Garrix to explore and shop official merchandise. High-contrast UI and smooth navigation.",
      longDescription: "This project was a deep dive into creating a high-energy, visual-heavy e-commerce experience. I focused on optimizing performance while maintaining a large number of heavy assets. The tech stack includes React for the UI, custom CSS for the animations, and JavaScript for the store logic.",
      live: "https://sparkling-kitsune-6d6b5b.netlify.app/",
      github: "https://github.com/wesgolf/Martin-Garrix-Ecommerce-Website",
      filterr: "web",
      style: "garrix"
    },
    {
      title: "CourseIQ",
      tech: "React + Firebase + CSS",
      img: "https://preview.redd.it/aaq3s78f9yl41.png?width=640&crop=smart&auto=webp&s=cd41f85db8dad883dabba73d3468ea6d61c781b9",
      description: "A golf stat tracking web app enabling users to analyze gameplay using advanced metrics. Built with React and Firebase for real-time data.",
      longDescription: "CourseIQ aims to solve the problem of complex golf record keeping. By providing a clean, mobile-first interface, players can track their rounds on the fly. Firebase handles all the real-time data synchronization across devices.",
      live: "",
      github: "https://github.com/wesgolf/courseiq",
      filterr: "web",
      style: "courseiq"
    },
    {
      title: "OnlyFriends",
      tech: "React + Firebase + APIs",
      img: "https://github.com/b4sleal/OnlyFriends/raw/main/examples/example1.gif",
      description: "A social networking app connecting university students by program and school. Created to help students find academic support and study buddies.",
      longDescription: "OnlyFriends was developed as a tool for university students to find peers within their specific programs. It uses Firebase for authentication and real-time messaging, and integrates several APIs for school data.",
      live: "",
      github: "https://github.com/b4sleal/OnlyFriends",
      filterr: "web",
      style: "onlyfriends"
    },
    {
      title: "Wes Music",
      tech: "Logic Pro + Final Cut + Branding",
      img: logo,
      description: "Personal music brand with 1M+ streams. Signed to Afrojack's Wall Recordings & others. Live performances across Ontario.",
      longDescription: "Wes Music is my creative outlet for sound design and music production. Launched during the 2020 lockdown, it has grown from a bedroom project into a full brand with 1 million+ streams on Spotify and Soundcloud. Signed to major labels including Afrojack's Wall Recordings, and have performed live across Ontario.",
      live: "https://soundcloud.com/wesmusic1",
      spotify: "https://open.spotify.com/artist/2tMGlOELT6IvxS5xZItMk3",
      github: "",
      filterr: "design",
      style: "music"
    },
    {
      title: "The Course Collectives",
      tech: "Affinity Designer",
      img: ccLogo,
      description: "Luxury golf course art prints blending traditional architecture with modern design aesthetics. Iconic routings transformed into museum-quality statements.",
      longDescription: "Drawing from my passion for golf course architecture, I design and sell custom prints of famous and local courses. Each print is handcrafted with a focus on historical accuracy and visual elegance. The brand identity mirrors high-end golf tradition with a sophisticated forest green and serif-heavy aesthetic.",
      live: "https://coursecollectives.com/",
      github: "",
      filterr: "design",
      style: "coursecollectives"
    },
    {
      title: "Regenyx Therapy",
      tech: "Next.js + Tailwind + Netlify + EasyPost + PayPal",
      img: "https://regenyxtherapy.com/og-image.png",
      description: "Full e-commerce setup with Next.js and custom shipping logic. Handled complex international shipping and payment processing.",
      longDescription: "A high-performance e-commerce platform built with Next.js and Tailwind CSS. Features deep integration with EasyPost for real-time shipping quotes and PayPal for secure checkout. Debugged and resolved complex international shipping challenges, ensuring a seamless global customer experience.",
      live: "https://regenyxtherapy.com",
      github: "https://github.com/peptides99-dev/site",
      filterr: "web",
      style: "regenyx"
    },
    {
      title: "Pin Sheet Generator",
      tech: "React + SVG Image Processing + Supabase + Tailwind",
      img: "https://pinsheetgenerator.netlify.app/og-image.png",
      description: "A custom-built pin sheet generator designed for Hamilton Golf & Country Club to streamline daily course setup and enhance player experience.",
      longDescription: "A custom-built pin sheet generator designed for Hamilton Golf & Country Club to streamline daily course setup and enhance player experience. The tool dynamically generates hole-by-hole pin locations with accurate front, middle, and back yardages, paired with clean visual layouts for easy use by staff and players.",
      live: "https://pinsheetgenerator.netlify.app",
      github: "",
      filterr: "web",
      style: "pinsheet"
    },
    {
      title: "Connect+",
      tech: "Adobe XD + UX/UI",
      img: "https://www.connect-international.org/wp-content/uploads/2023/09/Screenshot-2023-09-02-at-17.34.44-e1720653114632-1024x629.png",
      description: "A mental health support app designed to facilitate seamless peer connection and emotional support with intuitive navigation.",
      longDescription: "Connect+ is a UX/UI case study for a mental health networking app. The goal was to create a safe, calming interface that makes it easy for students to find peer support in high-stress environments.",
      live: "",
      filterr: "design",
      style: "connectplus"
    },
    {
      title: "Golf Course Design",
      tech: "Golf Course Architecture + CAD",
      img: drawing,
      description: "A personal design challenge focused on creating a full 18-hole golf course layout from scratch. Applies real-world architecture principles.",
      longDescription: "This project is an ongoing exploration into 18-hole course routing. Using CAD software, I'm developing a full layout that balances strategic playability with environmental sustainability.",
      live: "",
      github: "",
      filterr: "design",
      style: "design"
    }
  ];

  const workExperience = [
    {
      company: "Sun Life",
      location: "Waterloo, ON",
      role: "Project Management Specialist (Co-op)",
      period: "September 2024 - December 2024",
      highlights: [
        "Developed an automated timeline generator using HTML, JavaScript, and GitHub Copilot, streamlining team workflows and reducing manual effort",
        "Built a SharePoint site in collaboration with key stakeholders, balancing diverse needs to enhance organizational collaboration",
        "Coordinated and processed invoices for third-party vendors, ensuring timely payments and maintaining vendor satisfaction",
        "Introduced GitHub Copilot to the front-end development team, improving coding efficiency and fostering innovation"
      ]
    },
    {
      company: "Sun Life",
      location: "Waterloo, ON",
      role: "Private Operations Specialist (Co-op)",
      period: "January 2024 - April 2024",
      highlights: [
        "Led a pivotal project to create a centralized documentation system and KPI dashboard that utilized VBA, enhancing stakeholder access and organizational efficiency",
        "Mastered Jira, Confluence, and web design, significantly contributing to project success and operational support for the operations team",
        "Fostered collaboration and increased stakeholder satisfaction to 90% through effective communication and stakeholder engagement",
        "Overcame approval and dependency challenges by leveraging problem-solving skills, ensuring project milestones were met on time"
      ]
    },
    {
      company: "CiviConnect",
      location: "Beamsville, ON",
      role: "Web Development & Cloud Deployment Associate (Co-op)",
      period: "January 2023 - April 2023",
      highlights: [
        "Collaborated in functional teams to design and develop three websites using tools such as React, CSS, HTML, Strapi",
        "Analyzed customers’ requests and feedback to ensure understanding of their technical needs and challenges",
        "Utilized knowledge of efficient web development practices to optimize user experience and offer personalized product solutions to support their business success"
      ]
    }
  ];

  const filteredProjects = projects.filter((project) => {
    if (filter === "all") return true;
    if (filter === "web") return project.filterr === "web";
    if (filter === "design") return project.filterr === "design";
    return true;
  });

  const technicalSkills = [
    "JavaScript", "Python", "R", "SQL", "HTML/CSS", "React", "React Native", "Node.js", "Next.js", "Git/GitHub", "Firebase", "Supabase", "REST APIs", "JSON", "Backend Auth", "API integrations", "PayPal", "EasyPost",
    "Statistical Analysis", "Data Visualization", "Survey Design", "Quantitative Research", "Qualitative Analysis", "SPSS", "RStudio", "Excel", "Experimental Design", "Data Storytelling",
    "Linear Regression", "Model Diagnostics", "Optimization", "Backtracking Algorithms", "Algorithmic Thinking"
  ];

  const designCreativeSkills = [
    "UI/UX Design", "Affinity Designer", "Adobe Creative Suite", "Canva", "Figma", "Layout Design", "Typography", "Branding", "Print Design",
    "Full-stack Web Dev", "E-commerce", "Payment Processing", "Shipping Integrations", "Responsive Design", "SEO", "Netlify", "Website Optimization",
    "Logic Pro", "Music Composition", "Mixing & Mastering", "DJ Performance", "Sound Design", "Music Branding",
    "Cartographic Design", "GIS Mapping", "Geographic Data", "Literature Reviews", "APA Formatting", "Scientific Writing"
  ];

  const professionalSkills = [
    "Analytical Thinking", "Systems Thinking", "Critical Reasoning", "Troubleshooting", "Process Optimization", "Strategic Planning",
    "Professional Writing", "Technical Writing", "Presentation Skills", "Public Speaking", "Stakeholder Communication",
    "Team Leadership", "Mentoring", "Conflict Resolution", "Delegation", "Marketing Strategy", "Consumer Behavior", "Market Research",
    "Project Management", "Time Management", "Multi-project Coordination", "Independent Work Ethic", "Attention to Detail",
    "Creative Ideation", "Visual Storytelling", "Design Thinking", "Self-motivated", "Adaptable", "Curious Learner", "Growth Mindset"
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100
      }
    }
  };

  return (
    <div className="bg-background-light dark:bg-background-dark text-black dark:text-white font-sans transition-colors duration-300 min-h-screen flex flex-col grid-bg custom-cursor-area selection:bg-accent selection:text-black overflow-x-hidden">

      {/* Custom Cursor */}
      <div
        className={`custom-cursor hidden lg:block ${isHovering ? 'hovering' : ''}`}
        style={{ left: `${cursorPos.x}px`, top: `${cursorPos.y}px` }}
      />

      {/* Physics Background Container */}
      <div ref={physicsContainerRef} id="physics-container" />

      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-4 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto flex flex-col justify-center min-h-[80vh] relative z-10" id="home">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
          className="space-y-6"
        >
          <motion.p variants={itemVariants} className="text-xl sm:text-2xl font-bold bg-accent inline-block px-2 py-1 transform -rotate-1 border-2 border-black shadow-brutalist dark:shadow-brutalist-dark dark:text-black dark:border-white">
            Hi! My name is
          </motion.p>
          <motion.h1 variants={itemVariants} className="font-display font-bold text-7xl sm:text-8xl lg:text-9xl leading-none tracking-tighter">
            WESLEY<br />
            <span className="stroke-text transition-colors duration-500 glitch-hover">ROBERTSON</span>
          </motion.h1>
          <motion.p variants={itemVariants} className="text-xl sm:text-2xl max-w-3xl leading-relaxed font-medium border-l-4 border-secondary pl-6 py-2">
            I’m a developer, designer, and DJ — building cool things and making them look good.
          </motion.p>
          <motion.div variants={itemVariants} className="pt-8 flex gap-4">
            <a
              onMouseEnter={() => setIsHovering(true)}
              onMouseLeave={() => setIsHovering(false)}
              className="bg-black text-white dark:bg-white dark:text-black px-8 py-4 text-xl font-bold border-2 border-black dark:border-white shadow-brutalist hover:shadow-brutalist-hover hover:translate-x-[2px] hover:translate-y-[2px] transition-all flex items-center gap-2"
              href="#projects"
            >
              View My Work <i className="material-icons">arrow_downward</i>
            </a>
          </motion.div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
          className="mt-20 flex justify-center animate-bounce"
        >
          <i className="material-icons text-5xl">arrow_downward</i>
        </motion.div>
      </section>

      {/* Subtle Skills Marquee Section */}
      <section className="py-12 bg-white dark:bg-black border-y-2 border-black dark:border-white overflow-hidden relative z-20">
        <div className="flex flex-col gap-6">
          {/* Row 1: Technical */}
          <div className="animate-marquee flex gap-12 whitespace-nowrap">
            {[...technicalSkills, ...technicalSkills].map((skill, i) => (
              <span key={i} className="font-mono font-bold text-lg uppercase flex items-center gap-6">
                {skill} <span className="text-secondary opacity-50">•</span>
              </span>
            ))}
          </div>

          {/* Row 2: Design & Creative - Reverse */}
          <div className="animate-marquee-reverse flex gap-12 whitespace-nowrap border-y border-black/5 dark:border-white/5 py-2">
            {[...designCreativeSkills, ...designCreativeSkills].map((skill, i) => (
              <span key={i} className="font-mono font-bold text-lg uppercase flex items-center gap-6 text-gray-600 dark:text-gray-400">
                {skill} <span className="text-accent">★</span>
              </span>
            ))}
          </div>

          {/* Row 3: Professional & Traits */}
          <div className="animate-marquee flex gap-12 whitespace-nowrap">
            {[...professionalSkills, ...professionalSkills].map((skill, i) => (
              <span key={i} className="font-mono font-bold text-lg uppercase flex items-center gap-6">
                {skill} <span className="text-secondary opacity-50">/</span>
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-surface-light dark:bg-surface-dark border-y-2 border-black dark:border-white relative z-10" id="projects">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={containerVariants}
            className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6"
          >
            <div>
              <motion.h2 variants={itemVariants} className="font-display text-6xl font-bold mb-4">Projects</motion.h2>
              <motion.div variants={itemVariants} className="h-2 w-32 bg-accent"></motion.div>
            </div>
            <motion.div variants={itemVariants} className="flex flex-wrap gap-3 font-bold text-sm sm:text-base">
              <span className="mr-2 self-center font-display text-lg uppercase tracking-wide">Filter By:</span>
              <button
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                onClick={() => setFilter("all")}
                className={`px-4 py-2 border-2 border-black dark:border-white shadow-brutalist hover:shadow-brutalist-hover transition-all ${filter === 'all' ? 'bg-black text-white dark:bg-white dark:text-black translate-x-[2px] translate-y-[2px] shadow-none' : 'bg-transparent'}`}
              >
                All
              </button>
              <button
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                onClick={() => setFilter("web")}
                className={`px-4 py-2 border-2 border-black dark:border-white shadow-brutalist hover:shadow-brutalist-hover transition-all ${filter === 'web' ? 'bg-black text-white dark:bg-white dark:text-black translate-x-[2px] translate-y-[2px] shadow-none' : 'bg-transparent'}`}
              >
                Web Development
              </button>
              <button
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                onClick={() => setFilter("design")}
                className={`px-4 py-2 border-2 border-black dark:border-white shadow-brutalist hover:shadow-brutalist-hover transition-all ${filter === 'design' ? 'bg-black text-white dark:bg-white dark:text-black translate-x-[2px] translate-y-[2px] shadow-none' : 'bg-transparent'}`}
              >
                Graphic Design
              </button>
            </motion.div>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={containerVariants}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          >
            {filteredProjects.map((project, index) => (
              <motion.div
                key={project.title}
                variants={itemVariants}
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                onClick={() => setSelectedProject(project)}
                className="group border-2 border-black dark:border-white bg-background-light dark:bg-background-dark shadow-brutalist hover:shadow-brutalist-hover hover:translate-x-[2px] hover:translate-y-[2px] transition-all duration-200 flex flex-col h-full cursor-pointer"
              >
                {/* Dynamic Header based on project style */}
                <div className="h-64 overflow-hidden border-b-2 border-black dark:border-white relative">
                  {project.style === 'garrix' && (
                    <div className="absolute inset-0 bg-black flex items-center justify-center group-hover:bg-neutral-900 transition-colors overflow-hidden">
                      <div className="absolute inset-0 opacity-30">
                        {[...Array(10)].map((_, i) => (
                          <div key={i} className="absolute h-[1px] w-full bg-white opacity-20" style={{ top: `${i * 10}%` }}></div>
                        ))}
                      </div>
                      <span className="text-white text-9xl font-bold font-display opacity-80 group-hover:scale-110 transition-transform duration-500 animate-pulse-custom">+×</span>
                    </div>
                  )}
                  {project.style === 'onlyfriends' && (
                    <div className="absolute inset-0 bg-white dark:bg-neutral-800 flex items-center justify-center p-8 overflow-hidden">
                      <div className="w-full h-full border-4 border-black dark:border-gray-600 rounded-full flex items-center justify-center relative animate-float">
                        <span className="material-icons text-7xl text-gray-300 group-hover:text-secondary transition-colors">people</span>
                        <div className="absolute -top-2 -right-2 bg-accent w-8 h-8 border-2 border-black rounded-full animate-bounce"></div>
                      </div>
                    </div>
                  )}
                  {project.style === 'music' && (
                    <div className="absolute inset-0 bg-black flex items-center justify-center p-4">
                      <div className="w-full h-full flex items-center justify-center border-2 border-white rounded-full animate-spin-slow">
                        <svg className="w-full h-full fill-white" viewBox="0 0 100 100">
                          <defs><path d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" id={`circle-${index}`}></path></defs>
                          <text fontSize="14" fontWeight="bold" letterSpacing="2">
                            <textPath xlinkHref={`#circle-${index}`}>WES. WES. WES. WES. WES. </textPath>
                          </text>
                        </svg>
                      </div>
                      <span className="absolute text-white font-bold text-xl group-hover:scale-125 transition-transform">MUSIC</span>
                    </div>
                  )}
                  {project.style === 'connectplus' && (
                    <div className="absolute inset-0 bg-white dark:bg-neutral-800 flex items-center justify-center p-4 overflow-hidden">
                      <div className="relative z-10 animate-float">
                        <h2 className="text-4xl font-extrabold text-blue-500 flex flex-col items-center">
                          <span>let's</span>
                          <span className="text-black dark:text-white text-5xl">CONNECT</span>
                        </h2>
                      </div>
                      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-blue-400 via-transparent to-transparent animate-pulse-custom"></div>
                      <div className="absolute top-2 left-2 text-blue-500 opacity-20 text-6xl font-black">?</div>
                      <div className="absolute bottom-2 right-2 text-blue-500 opacity-20 text-6xl font-black">!</div>
                    </div>
                  )}
                  {project.style === 'courseiq' && (
                    <div className="absolute inset-0 bg-neutral-100 dark:bg-neutral-900 flex items-center justify-center p-4 overflow-hidden">
                      <img
                        alt={project.title}
                        className="w-full h-full object-cover filter grayscale group-hover:grayscale-0 group-hover:scale-110 transition-all duration-700"
                        src={project.img}
                      />
                      <div className="absolute inset-0 border-[16px] border-white/30 pointer-events-none"></div>
                      <div className="absolute top-4 left-4 w-12 h-12 border-4 border-black dark:border-white rounded-full flex items-center justify-center animate-spin-slow">
                        <div className="w-2 h-2 bg-black dark:bg-white rounded-full"></div>
                      </div>
                    </div>
                  )}
                  {project.style === 'coursecollectives' && (
                    <div className="absolute inset-0 bg-white flex items-center justify-center p-8 overflow-hidden">
                      <img
                        alt={project.title}
                        className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                        src={project.img}
                      />
                      <div className="absolute inset-0 border-4 border-[#1A5F1A]/10 pointer-events-none"></div>
                    </div>
                  )}
                  {project.style === 'regenyx' && (
                    <div className="absolute inset-0 bg-[#3B82F6] flex items-center justify-center p-4 overflow-hidden">
                      <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]"></div>
                      <div className="relative z-10 text-white font-display text-center">
                        <h2 className="text-4xl font-extrabold tracking-tighter italic">REGENYX</h2>
                        <div className="h-1 w-20 bg-white mx-auto mt-2"></div>
                      </div>
                    </div>
                  )}
                  {project.style === 'pinsheet' && (
                    <div className="absolute inset-0 bg-[#1E5631] flex items-center justify-center p-4 overflow-hidden">
                      <div className="relative z-10 w-full h-full border-2 border-white/30 flex flex-col items-center justify-center gap-2">
                        <img
                          src="https://hamiltongolf.netlify.app/hamilton_logo_white.png"
                          className="w-24 h-24 object-contain opacity-80"
                          alt="HGCC"
                        />
                        <span className="text-white font-mono text-[10px] font-black tracking-widest bg-white/10 px-2 py-1">PIN GENERATOR</span>
                      </div>
                    </div>
                  )}
                  {project.style === 'design' && (
                    <div className="absolute inset-0 bg-neutral-200 dark:bg-neutral-800 flex items-center justify-center overflow-hidden">
                      <img
                        alt={project.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-all duration-500"
                        src={project.img}
                      />
                      <div className="absolute inset-0 border-2 border-black/10 group-hover:border-black/0 transition-all"></div>
                      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                        <div className="w-[80%] h-[80%] border border-white/50 animate-pulse-custom"></div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="p-6 flex-grow flex flex-col">
                  <h3 className="font-display text-2xl font-bold mb-2">{project.title}</h3>
                  <p className="text-xs font-mono mb-4 uppercase tracking-wider text-gray-600 dark:text-gray-400 border-b border-black dark:border-white pb-2 inline-block">{project.tech}</p>
                  <p className="text-sm leading-relaxed mb-6 flex-grow">
                    {project.description}
                  </p>
                  <div className="flex border-t-2 border-black dark:border-white -mx-6 -mb-6 mt-auto divide-x-2 divide-black dark:divide-white">
                    {project.live && (
                      <a className="flex-1 py-3 text-center font-bold hover:bg-accent hover:text-black transition-colors text-sm uppercase" href={project.live} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>
                        WEBSITE
                      </a>
                    )}
                    {project.github && (
                      <a className="flex-1 py-3 text-center font-bold hover:bg-secondary hover:text-white transition-colors text-sm uppercase" href={project.github} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>GitHub</a>
                    )}
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Experience Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-background-light dark:bg-background-dark border-b-2 border-black dark:border-white relative z-10" id="experience">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={containerVariants}
            className="mb-16"
          >
            <motion.h2 variants={itemVariants} className="font-display text-6xl font-bold mb-4 uppercase italic">Experience</motion.h2>
            <motion.div variants={itemVariants} className="h-2 w-32 bg-secondary"></motion.div>
          </motion.div>

          <div className="relative mt-20">
            {/* Scrollable Timeline Container */}
            <div className="overflow-x-auto no-scrollbar pb-24 pt-24 px-4">
              <div className="flex items-center min-w-[max-content] h-[550px] relative">
                {/* Continuous Timeline Axis Line */}
                <div className="absolute top-1/2 left-0 right-0 h-2 bg-black dark:bg-white z-0 -translate-y-1/2">
                  <div className="absolute top-1/2 right-0 -translate-y-1/2 w-0 h-0 border-t-[10px] border-t-transparent border-b-[10px] border-b-transparent border-l-[20px] border-l-black dark:border-l-white"></div>
                </div>

                {[...workExperience].reverse().map((job, idx) => (
                  <motion.div
                    key={idx}
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: idx * 0.1 }}
                    className="flex flex-col items-center w-[300px] lg:w-[450px] relative flex-shrink-0 h-full"
                  >
                    {/* Diamond Node on Axis */}
                    <div className="absolute top-1/2 -translate-y-1/2 w-10 h-10 bg-accent border-4 border-black dark:border-white flex items-center justify-center rotate-45 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] z-30">
                      <div className="w-3 h-3 bg-black dark:bg-white rounded-full"></div>
                    </div>

                    {/* Alternating Card Content */}
                    {idx % 2 === 0 ? (
                      /* TOP CARD */
                      <div className="absolute bottom-[calc(50%+20px)] flex flex-col items-center w-full">
                        <div className="bg-white dark:bg-neutral-900 border-4 border-black dark:border-white p-5 shadow-brutalist dark:shadow-brutalist-dark hover:translate-x-1 hover:translate-y-1 hover:shadow-none transition-all cursor-default group w-[280px] lg:w-[380px] z-20">
                          <div className="mb-2">
                            <h3 className="font-display text-lg font-black uppercase tracking-tighter leading-none mb-1">{job.company}</h3>
                            <p className="text-xs font-bold text-secondary uppercase italic leading-tight">{job.role}</p>
                          </div>
                          <ul className="space-y-1.5 mb-3">
                            {job.highlights.slice(0, 2).map((item, i) => (
                              <li key={i} className="flex items-start gap-2">
                                <span className="text-accent text-lg font-black leading-none inline-block w-[115%]">/</span>
                                <p className="text-[10px] leading-tight font-medium text-gray-700 dark:text-gray-300">{item}</p>
                              </li>
                            ))}
                          </ul>
                          <div className="flex items-center justify-between border-t-2 border-black/10 dark:border-white/10 pt-2">
                            <p className="text-[9px] font-bold text-gray-500 uppercase tracking-widest">{job.location}</p>
                            <p className="font-mono text-[9px] font-bold opacity-60 italic">{job.period}</p>
                          </div>
                        </div>
                        <div className="w-1.5 h-16 bg-black dark:bg-white"></div>
                      </div>
                    ) : (
                      /* BOTTOM CARD */
                      <div className="absolute top-[calc(50%+20px)] flex flex-col items-center w-full">
                        <div className="w-1.5 h-16 bg-black dark:bg-white"></div>
                        <div className="bg-white dark:bg-neutral-900 border-4 border-black dark:border-white p-5 shadow-brutalist dark:shadow-brutalist-dark hover:translate-x-1 hover:translate-y-1 hover:shadow-none transition-all cursor-default group w-[280px] lg:w-[380px] z-20">
                          <div className="mb-2">
                            <h3 className="font-display text-lg font-black uppercase tracking-tighter leading-none mb-1">{job.company}</h3>
                            <p className="text-xs font-bold text-secondary uppercase italic leading-tight">{job.role}</p>
                          </div>
                          <ul className="space-y-1.5 mb-3">
                            {job.highlights.slice(0, 2).map((item, i) => (
                              <li key={i} className="flex items-start gap-2">
                                <span className="text-accent text-lg font-black leading-none inline-block w-[115%]">/</span>
                                <p className="text-[10px] leading-tight font-medium text-gray-700 dark:text-gray-300">{item}</p>
                              </li>
                            ))}
                          </ul>
                          <div className="flex items-center justify-between border-t-2 border-black/10 dark:border-white/10 pt-2">
                            <p className="text-[9px] font-bold text-gray-500 uppercase tracking-widest">{job.location}</p>
                            <p className="font-mono text-[9px] font-bold opacity-60 italic">{job.period}</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </motion.div>
                ))}
                <div className="w-40 flex-shrink-0"></div>
              </div>
            </div>

            {/* Mobile Scroll Indicator */}
            <div className="flex justify-center mt-2 lg:hidden">
              <p className="text-[10px] font-mono opacity-40 uppercase tracking-widest animate-pulse">Swipe to navigate →</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto relative z-10" id="connect">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={containerVariants}
          className="flex flex-col md:flex-row gap-12"
        >
          <div className="md:w-1/2">
            <motion.h2 variants={itemVariants} className="font-display text-7xl font-bold leading-tight uppercase tracking-tighter mb-6">
              Let's Build <br /> <span className="text-accent underline decoration-8 decoration-black dark:decoration-white underline-offset-4">Something Cool</span>
            </motion.h2>
            <motion.p variants={itemVariants} className="text-2xl font-medium mb-8">
              Whether it's a web app, a brand identity, or a killer set - I'm always down to chat.
            </motion.p>
            <motion.div variants={itemVariants} className="space-y-4">
              <p className="font-mono text-xl">→ wesleyrob27@gmail.com</p>
              <p className="font-mono text-xl">→ Ancaster, Ontario</p>
            </motion.div>
          </div>

          <motion.div variants={itemVariants} className="md:w-1/2 bg-white dark:bg-surface-dark border-4 border-black dark:border-white p-8 shadow-brutalist dark:shadow-brutalist-dark">
            <form className="space-y-6">
              <div>
                <label className="brutalist-label">Name</label>
                <input type="text" className="brutalist-input" placeholder="WESLEY ROBERTSON" />
              </div>
              <div>
                <label className="brutalist-label">Email</label>
                <input type="email" className="brutalist-input" placeholder="HELLO@WORLD.COM" />
              </div>
              <div>
                <label className="brutalist-label">Message</label>
                <textarea rows="4" className="brutalist-input" placeholder="TELL ME ABOUT YOUR PROJECT..."></textarea>
              </div>
              <button
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                type="button"
                className="w-full bg-accent text-black py-4 text-2xl font-black border-4 border-black shadow-brutalist hover:shadow-brutalist-hover hover:translate-x-[2px] hover:translate-y-[2px] transition-all uppercase tracking-tighter"
              >
                Send Message
              </button>
            </form>
          </motion.div>
        </motion.div>
      </section>

      <Footer />

      {/* Project Drawer */}
      <AnimatePresence>
        {selectedProject && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setSelectedProject(null)}
              className="drawer-backdrop"
            />
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ type: 'spring', damping: 25, stiffness: 300 }}
              className="drawer-content"
            >
              <button
                onClick={() => setSelectedProject(null)}
                className="self-start mb-8 p-2 border-2 border-black dark:border-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
              >
                <i className="material-icons align-middle">close</i> CLOSE
              </button>

              <div className="space-y-8">
                <div className="h-48 sm:h-80 border-4 border-black dark:border-white overflow-hidden relative">
                  {selectedProject.style === 'garrix' && (
                    <div className="absolute inset-0 bg-black flex items-center justify-center overflow-hidden">
                      <div className="absolute inset-0 opacity-30">
                        {[...Array(10)].map((_, i) => (
                          <div key={i} className="absolute h-[1px] w-full bg-white opacity-20" style={{ top: `${i * 10}%` }}></div>
                        ))}
                      </div>
                      <span className="text-white text-9xl font-bold font-display animate-pulse-custom">+×</span>
                    </div>
                  )}
                  {selectedProject.style === 'onlyfriends' && (
                    <div className="absolute inset-0 bg-white dark:bg-neutral-800 flex items-center justify-center p-8 overflow-hidden">
                      <div className="w-48 h-48 border-4 border-black dark:border-gray-600 rounded-full flex items-center justify-center relative animate-float">
                        <span className="material-icons text-7xl text-gray-300">people</span>
                        <div className="absolute -top-2 -right-2 bg-accent w-8 h-8 border-2 border-black rounded-full animate-bounce"></div>
                      </div>
                    </div>
                  )}
                  {selectedProject.style === 'music' && (
                    <div className="absolute inset-0 bg-black flex items-center justify-center p-4">
                      <div className="w-48 h-48 sm:w-64 sm:h-64 flex items-center justify-center border-2 border-white rounded-full animate-spin-slow">
                        <svg className="w-full h-full fill-white" viewBox="0 0 100 100">
                          <defs><path d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" id="modal-circle"></path></defs>
                          <text fontSize="14" fontWeight="bold" letterSpacing="2">
                            <textPath xlinkHref="#modal-circle">WES. WES. WES. WES. WES. </textPath>
                          </text>
                        </svg>
                      </div>
                      <span className="absolute text-white font-bold text-2xl">MUSIC</span>
                    </div>
                  )}
                  {selectedProject.style === 'connectplus' && (
                    <div className="absolute inset-0 bg-white dark:bg-neutral-800 flex items-center justify-center p-4 overflow-hidden">
                      <div className="relative z-10 animate-float text-center">
                        <h2 className="text-5xl font-extrabold text-blue-500 flex flex-col items-center">
                          <span>let's</span>
                          <span className="text-black dark:text-white text-6xl">CONNECT</span>
                        </h2>
                      </div>
                      <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-blue-400 via-transparent to-transparent animate-pulse-custom"></div>
                      <div className="absolute top-4 left-4 text-blue-500 opacity-20 text-8xl font-black">?</div>
                      <div className="absolute bottom-4 right-4 text-blue-500 opacity-20 text-8xl font-black">!</div>
                    </div>
                  )}
                  {selectedProject.style === 'courseiq' && (
                    <div className="absolute inset-0 bg-neutral-100 dark:bg-neutral-900 flex items-center justify-center p-4 overflow-hidden">
                      <img
                        alt={selectedProject.title}
                        className="w-full h-full object-cover"
                        src={selectedProject.img}
                      />
                      <div className="absolute inset-0 border-[20px] border-white/30 pointer-events-none"></div>
                      <div className="absolute top-6 left-6 w-16 h-16 border-4 border-black dark:border-white rounded-full flex items-center justify-center animate-spin-slow">
                        <div className="w-3 h-3 bg-black dark:bg-white rounded-full"></div>
                      </div>
                    </div>
                  )}
                  {selectedProject.style === 'coursecollectives' && (
                    <div className="absolute inset-0 bg-white flex items-center justify-center p-8 overflow-hidden">
                      <img
                        alt={selectedProject.title}
                        className="w-full h-full object-contain"
                        src={selectedProject.img}
                      />
                    </div>
                  )}
                  {selectedProject.style === 'regenyx' && (
                    <div className="absolute inset-0 bg-[#3B82F6] flex items-center justify-center p-8 overflow-hidden">
                      <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]"></div>
                      <h2 className="text-white text-6xl font-black italic tracking-tighter shadow-xl transform skew-x-[-12deg]">REGENYX</h2>
                    </div>
                  )}
                  {selectedProject.style === 'pinsheet' && (
                    <div className="absolute inset-0 bg-[#1E5631] flex flex-col items-center justify-center p-8 overflow-hidden">
                      <img
                        src="https://hamiltongolf.netlify.app/hamilton_logo_white.png"
                        className="w-48 h-48 object-contain mb-4 animate-float"
                        alt="HGCC"
                      />
                      <p className="text-white font-mono tracking-widest text-lg font-black">PIN SHEET GENERATOR</p>
                    </div>
                  )}
                  {selectedProject.style === 'design' && (
                    <div className="absolute inset-0 bg-neutral-200 dark:bg-neutral-800 flex items-center justify-center overflow-hidden">
                      <img
                        alt={selectedProject.title}
                        className="w-full h-full object-cover"
                        src={selectedProject.img}
                      />
                      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                        <div className="w-[85%] h-[85%] border-4 border-white/40 animate-pulse-custom"></div>
                      </div>
                    </div>
                  )}
                  {(!selectedProject.style || !['garrix', 'onlyfriends', 'music', 'connectplus', 'design', 'courseiq', 'coursecollectives', 'pinsheet', 'regenyx'].includes(selectedProject.style)) && (
                    <img src={selectedProject.img} alt="" className="w-full h-full object-cover" />
                  )}
                </div>

                <div>
                  <span className="text-sm font-mono uppercase bg-accent text-black px-2 py-1 mb-2 inline-block shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]">
                    {selectedProject.tech}
                  </span>
                  <h2 className="font-display text-5xl font-black uppercase tracking-tighter leading-none mt-2">
                    {selectedProject.title}
                  </h2>
                </div>

                <div className="prose prose-xl dark:prose-invert">
                  <p className="font-bold text-2xl leading-tight">
                    {selectedProject.description}
                  </p>
                  <p className="text-lg opacity-80">
                    {selectedProject.longDescription}
                  </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 pt-8 border-t-2 border-black/10 dark:border-white/10">
                  {selectedProject.live && (
                    <a className="flex-1 bg-black text-white dark:bg-white dark:text-black py-4 text-center font-black text-xl border-2 border-black dark:border-white shadow-brutalist hover:shadow-brutalist-hover transition-all" href={selectedProject.live} target="_blank" rel="noreferrer">
                      WEBSITE
                    </a>
                  )}
                  {selectedProject.spotify && (
                    <a className="flex-1 bg-[#1DB954] text-white py-4 text-center font-black text-xl border-2 border-black shadow-brutalist hover:shadow-brutalist-hover transition-all" href={selectedProject.spotify} target="_blank" rel="noreferrer">
                      SPOTIFY
                    </a>
                  )}
                  {selectedProject.github && (
                    <a className="flex-1 bg-white dark:bg-black text-black dark:text-white py-4 text-center font-black text-xl border-2 border-black dark:border-white shadow-brutalist hover:shadow-brutalist-hover transition-all" href={selectedProject.github} target="_blank" rel="noreferrer">
                      GITHUB
                    </a>
                  )}
                </div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
}
